module.exports = __webpack_public_path__ + "3f3137f83cd9025b5556c0c068868521.svg";